import { gql } from '@apollo/client';

export const GET_SEARCH_TV_PROGRAM = gql`
  query GetSearchTvProgram(
    $query: NonEmptyTrimmedString!
    $context: TvSearchContextType!
  ) {
    searchTvPrograms(query: $query, first: 25, context: $context) {
      id
      title
      boneUUID
      channel
      startedAt
    }
  }
`;
